import { modules, track } from 'App/helpers/segmentHelper';

angular.module('upHelpers').factory('SegmentHelper', function () {
	return {
		module: modules,
		track
	};
});
